import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, HostListener, Input, Output, inject } from '@angular/core';

@Component({
    standalone: false,
    selector: 'por-overlay',
    templateUrl: './overlay.component.html',
    styleUrls: ['./overlay.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverlayComponent {
    private readonly elementRef = inject(ElementRef);

    @Input() isOpen = false; // Overlay visibility state
    @Input() trigger!: CdkOverlayOrigin; // Pass the trigger from parent
    @Input() featureName!: string;
    @Input() layout: string | undefined;

    @Output() readonly closeOverlayClick = new EventEmitter<void>();

    closeOverlay() {
        this.closeOverlayClick.emit(); // Emit close event to parent
    }

    @HostListener('document:click', ['$event.target'])
    public onPageClick(targetElement: HTMLElement) {
        if (
            this.isOpen &&
            !this.elementRef.nativeElement.contains(targetElement) &&
            !this.trigger.elementRef.nativeElement.contains(targetElement) &&
            !(targetElement instanceof HTMLInputElement && targetElement.type === 'checkbox')
        ) {
            this.closeOverlay();
        }
    }

    /**
     * Prevent closing the overlay when clicking inside it.
     */
    onOverlayClick(event: MouseEvent) {
        event.stopPropagation();
    }
}
